export enum CardTitle {
  Address = 'Address',
  BankAccount = 'Bank Account',
  Contact = 'Contact',
  FederalTaxes = 'Federal Taxes',
  Personal = 'Personal',
  StateTaxes = 'State Taxes',
}

export enum CardIcon {
  File = 'fal fa-file-invoice-dollar',
  Home = 'fal fa-home-alt',
  Mobile = 'fal fa-mobile-alt',
  University = 'fal fa-university',
  User = 'fal fa-user',
}

export enum CardLabel {
  Address1 = 'Address 1',
  Address2 = 'Address 2',
  Allowances = 'Allowances',
  BankAccount = 'Bank Account',
  BankName = 'Bank Name',
  BankNumber = 'Bank Number',
  BankType = 'Bank Type',
  Birthdate = 'Birthdate',
  City = 'City',
  ClaimDependentsAmount = 'Claim Dependents Amount',
  Deductions = 'Deductions',
  Email = 'Email',
  EmergencyContact = 'Emergency Contact',
  ExtraWithholding = 'Extra Witholding',
  FilingStatus = 'Filing Status',
  Home = 'Home',
  HomePhone = 'Home Phone',
  IncomeState = 'Income Filing State',
  MobilePhone = 'Mobile Phone',
  MultipleJobsOrSpouse = 'Multiple Jobs or Spouse Also Works',
  Name = 'Name',
  OtherIncome = 'Other Income',
  Sex = 'Sex',
  State = 'State',
  SSN = 'Social Security Number',
  UnemploymentFilingState = 'Unemployment Filing State',
  WithholdingTax = 'Withholding Tax',
  Zip = 'Zip',
}

export enum paperCheckListItems {
  Secure = 'Secure deposits of your paychecks',
  Fast = 'Get your hard earned money faster',
  Online = 'View your paystubs online',
  EcoFriendly = 'Save some trees!',
}
